import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";

interface LineBoxProps {
  children: JSX.Element | JSX.Element[];
  boxHeight?: string;
  boxPadding?: string;
  notScroll?: boolean;
  center?: boolean;
  [key: string]: any;
}

interface SLineBoxContainer {
  boxHeight?: string;
  boxPadding?: string;
  notScroll?: boolean;
  center?: boolean;
}

export default function LineBox({
  children,
  boxHeight,
  boxPadding,
  notScroll,
  center,
  scrollBottomToTop,
  ...rest
}: LineBoxProps) {
  const lineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollBottomToTop) {
      setTimeout(() => {
        if (lineRef.current) {
          lineRef.current.scrollTo({
            left: 0,
            behavior: "smooth",
            top: lineRef.current.scrollHeight,
          });
        }
      }, 500);
    }
  }, []);

  return (
    <LineBoxContainer
      boxHeight={boxHeight}
      boxPadding={boxPadding}
      notScroll={notScroll}
      center={center}
      ref={lineRef}
      {...rest}
    >
      {children}
    </LineBoxContainer>
  );
}

const defaultStyle = css<SLineBoxContainer>`
  padding: ${({ boxPadding }) => boxPadding ?? "28px 40px 40px 40px"};
  overflow-x: ${({ notScroll }) => (notScroll ? "hidden" : "scroll")};
`;

const fixedHeight = css<SLineBoxContainer>`
  display: ${({ center }) => (center ? "flex" : "block")};
  align-items: cetner;
  padding: ${({ boxPadding, center }) =>
    center ? "auto" : boxPadding ?? "28px 40px 40px 40px"};
  overflow-x: ${({ center, notScroll }) =>
    center && notScroll ? "hidden" : "scroll"};
`;

const LineBoxContainer = styled.div<SLineBoxContainer>`
  width: 100%;
  height: ${({ boxHeight }) => (boxHeight ? `${boxHeight}` ?? "auto" : "auto")};
  border-radius: 5px;
  border: solid 1px ${({ theme }) => theme.buttonColor.lineNormal};
  background-color: #ffffff;
  padding: 0 40px;

  ${({ boxHeight }) => (boxHeight ? fixedHeight : defaultStyle)}
`;
